import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/lib/auth";
import BottomNav from "@/components/BottomNav";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Awareness from "@/pages/Awareness";
import Dashboard from "@/pages/Dashboard";
import Profile from "@/pages/Profile";
import Vitals from "@/pages/Vitals";
import BookAppointment from "@/pages/BookAppointment";
import AppointmentHistory from "@/pages/AppointmentHistory";
import Meeting from "@/pages/Meeting";

const RequireAuth = ({ children }) => {
  const { token } = useAuth();
  const loc = useLocation();
  if (!token) return <Navigate to="/login" state={{ from: loc }} replace />;
  return children;
};

const Shell = ({ children }) => (
  <div className="mobile-shell">
    {children}
    <BottomNav />
  </div>
);

const App = () => (
  <BrowserRouter>
    <AuthProvider>
      <Shell>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/awareness" element={<Awareness />} />
          <Route path="/meeting" element={<Meeting />} />

          <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
          <Route path="/profile" element={<RequireAuth><Profile /></RequireAuth>} />
          <Route path="/vitals" element={<RequireAuth><Vitals /></RequireAuth>} />
          <Route path="/book" element={<RequireAuth><BookAppointment /></RequireAuth>} />
          <Route path="/appointments" element={<RequireAuth><AppointmentHistory /></RequireAuth>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Shell>
    </AuthProvider>
  </BrowserRouter>
);

export default App;
